const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const validateNumber = (number) => !isNaN(number);

const validateMSISDN = (msisdn) => {
  const re = /^[1-9]{1}[0-9]{3,17}$/;
  return re.test(String(msisdn));
}

export default {
  validateEmail,
  validateMSISDN,
  validateNumber
}



// WEBPACK FOOTER //
// ./src/helpers/validators.js